import { connect } from 'react-redux';
import { isEmpty, filter } from 'lodash';
import SizeSelector from 'app/commonComponents/sizeSelector/sizeSelector';
import { sizeSelected, sizeDeselected } from './sizeSelectorActions';
import { getClassificationPropertyDetailed } from '../productDetailsUtils';

const mapStateToProps = ({ detailsPage }) => {
  const hasItemOutOfStock = sizes => filter(sizes, item => item.count <= 0).length > 0;
  const selectedSizeOutOfTheStock = detailsPage.selectedSize && detailsPage.selectedSize.count <= 0;
  const { classifications } = detailsPage.loadedProduct;

  let selectedSizeItem = !isEmpty(detailsPage.selectedSize) ? detailsPage.selectedSize : null;
  if (!isEmpty(selectedSizeItem)) {
    selectedSizeItem = !isEmpty(detailsPage.sizeSelectedItem) ? detailsPage.sizeSelectedItem : null;
  }

  return {
    ...detailsPage,
    sizes: detailsPage.sizes,
    hasStock: detailsPage.hasStock, // display all OOS sizes: HYB-1231
    gender: getClassificationPropertyDetailed(classifications, 'gender'),
    silhouette: getClassificationPropertyDetailed(classifications, 'silhouette'),
    selectedSizeItem,
    loadedProduct: detailsPage.loadedProduct,
    displaySizeOutOfStockLegend: !selectedSizeOutOfTheStock && hasItemOutOfStock(detailsPage.sizes),
    productType: detailsPage.productType,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { onSizeSelected, onSizeDeselected } = props;
  return {
    // eslint-disable-next-line no-unused-vars
    onSizeSelected(sizeItemSelected, loadedProduct) {
      dispatch(sizeSelected(sizeItemSelected));
      return onSizeSelected && onSizeSelected(sizeItemSelected);
    },
    onSizeDeselected(sizeItemDeselected) {
      dispatch(sizeDeselected(sizeItemDeselected));
      return onSizeDeselected && onSizeDeselected(sizeItemDeselected);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SizeSelector);
